import { render, staticRenderFns } from "./TruewalletDepositWithQRCodePanel.vue?vue&type=template&id=583d9548&"
import script from "./TruewalletDepositWithQRCodePanel.vue?vue&type=script&lang=js&"
export * from "./TruewalletDepositWithQRCodePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports